<template>
  <v-card outlined>
    <v-card-text>
      <div class="d-flex align-center" style="gap: 12px">
        <v-icon>mdi-account-hard-hat</v-icon>
        <div class="flex-grow-1">
          <div class="text-subtitle-1 font-weight-medium text--primary">{{ $t('charging-point.interventions.title') }}</div>
          <div v-if="!loading && !items.length" class="text-caption text--secondary">{{ $t('charging-point.interventions.none') }}</div>
        </div>
        <v-btn icon small :loading="loading" :title="$t('refresh')" @click="load"><v-icon small>mdi-refresh</v-icon></v-btn>
      </div>
      <div v-for="item in items" :key="item.id" class="d-flex align-center flex-wrap py-1" style="gap: 8px">
        <v-chip x-small :color="item.open ? 'success' : 'grey'" dark>{{ $t(item.open ? 'charging-point.interventions.open' : `charging-point.interventions.closure.${item.closure}`) }}</v-chip>
        <div class="flex-grow-1 text-body-2">
          <span class="font-weight-medium">{{ item.technicianName }}</span>
          · {{ $t(`charging-point.interventions.kind.${item.kind}`) }}
          <span v-if="item.testMode" class="success--text"> · {{ $t('charging-point.interventions.test-mode') }}</span>
        </div>
        <div class="text-caption text--secondary">
          {{ formatDate(item.openedAt, 'DD/MM/YYYY HH:mm') }}<template v-if="item.closedAt"> → {{ formatDate(item.closedAt, 'HH:mm') }}</template>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ChargingPointRepository from "@repository/ChargingPointRepository";

// Qui est intervenu sur la borne (pose ou dépannage), quand, et si le mode test est actif.
export default {
  props: {
    chargingPoint: Object,
  },

  data() {
    return { items: [], loading: false }
  },

  watch: {
    'chargingPoint.id'() {
      this.load()
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      if (!this.chargingPoint) return
      this.loading = true
      ChargingPointRepository.interventions(this.chargingPoint.id).then(result => {
        this.items = result.items
      }).catch(err => {
        this.notifyError(err)
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
